module.exports = __webpack_public_path__ + "static/media/game_from_above.b55e223c.jpg";